<script setup lang="ts">
/**
 * Lignes « Frais Stripe déduits − 0,43 € » / « Commission Donoor déduite »
 * sous « L'association reçoit … » des pages de don et de cagnotte.
 *
 * Karim 14/10/2026 : sans elles, « reçoit 9,57 € » face à « 10 € » laissait
 * le donateur deviner où passait l'argent. N'apparaissent que si le donateur
 * ne couvre PAS les frais (sinon rien n'est retiré du don).
 */
import type { DetailNetAssociation } from "~/utils/netAssociationEstime";

const props = defineProps<{
  detail: DetailNetAssociation;
  /** Prestataire qui encaissera : on n'écrit pas « Stripe » pour un paiement PayPal. */
  prestataire?: "stripe" | "paypal";
  formatAmount: (amount: number) => string;
}>();

const { t } = useI18n();
const nomPrestataire = computed(() => (props.prestataire === "paypal" ? "PayPal" : "Stripe"));
</script>

<template>
  <div v-if="detail.frais > 0 || detail.commission > 0" class="-mt-2 space-y-1 text-sm text-gray-500 dark:text-gray-400">
    <div v-if="detail.frais > 0" class="flex justify-between items-center">
      <span>{{ t('don.deductionsAssociation.fraisDeduits', { provider: nomPrestataire }) }}</span>
      <span>− {{ formatAmount(detail.frais) }}</span>
    </div>
    <div v-if="detail.commission > 0" class="flex justify-between items-center">
      <span>{{ t('don.deductionsAssociation.commissionDeduite') }}</span>
      <span>− {{ formatAmount(detail.commission) }}</span>
    </div>
  </div>
</template>
